import { render } from "react-dom";
import React, { Component } from "react";
import Tabs from "react-responsive-tabs";
import { withRouter } from "react-router-dom";
import "react-responsive-tabs/styles.css";
import config from "../../config";
import "./HeaderMenu.scss";

class HeaderMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerMenus: [],
            hideMenuOptions: false,
        };
    }

    componentDidMount() {
        if (this.props.user && this.props.user.channel == "sales_channel") {
            this.setState({ hideMenuOptions: true }, () => {
                this.pushMenus();
            });
        } else {
            this.setState({ hideMenuOptions: false }, () => {
                this.pushMenus();
            });
        }
    }

    getTabs() {
        return this.state.headerMenus.map((president, index) => ({
            title: president.title,
            key: president.link,
            tabClassName: "tab",
            panelClassName: "panel",
            disabled: false,
        }));
    }
    redirect(path) {
        if (path.includes("https://") || path.includes("http://")) {
            var win = window.open(path, "_blank");
            win.focus();
        } else {
            this.props.history.push(`/${path}`);
            this.props.tabShowActive(path);
        }
    }

    pushMenus() {
        let menus = [];
        if (this.props?.user?.id == 1613 || this.props?.user?.id == 581) {
            menus.push({ title: "Application V2", link: "v2/applications" });
            menus.push({ title: "MCC V2", link: "v2/mcc" });
            menus.push({ title: "Processors V2", link: "v2/processors" });
        }
        menus.push({ title: "Applications", link: "applications" });


        if (this.props.user.organization.enable_agent_training == 1) {
            menus.push({
                title: "Agent Training",
                link: "https://paymentcloud.isoquote.com/oidc/240518168592/start",
            });
        }
        menus.push({ title: "Merchants", link: "merchants" });
        if (this.props.isPcAdmin) {
            menus.push({ title: "Equipment", link: "equipments" });
        }
        if (
            (this.props.user.role === "agent" &&
                this.props.user.is_view_residual) ||
            this.props.user.role === "admin"
        ) {
            if (this.props.isPcAdmin || this.props.is_ems_pc_admin) {
                menus.push({ title: "Organizations", link: "organization" });
            } else {
                let link = "organization/" + this.props.user.organization_id;
                menus.push({
                    title: "Organizations",
                    link: "organization/" + this.props.user.organization_id,
                });
            }
        }
        if (this.state.hideMenuOptions === false) {
            if (this.props.user.role) {
                menus.push({ title: "Templates ", link: "pricing-equipment" });
                if (
                    this.props.user.role === "admin" &&
                    config.paymentcloud &&
                    config.paymentcloud.RESIDUAL_SYSTEM &&
                    config.paymentcloud.RESIDUAL_SYSTEM.includes(
                        this.props.user.id,
                    )
                ) {
                    menus.push({ title: "Residuals", link: "residuals" });
                }
                if (this.props.isPcAdmin) {
                    menus.push(
                        { title: "Mcc", link: "mcc" },
                        { title: "Processors", link: "bank" },
                    );

                }
            }
        }
        this.setState({ headerMenus: [] }, () => {
            this.setState({ headerMenus: menus });
        });
    }

    render() {
        return (
            <div className="header-menu-tab">
                <Tabs
                    items={this.getTabs()}
                    onChange={(e) => this.redirect(e)}
                    transformWidth={200}
                    transform={true}
                    showMore={true}
                    showMoreLabel="..."
                    selectedTabKey={
                        this.props.currentRoute
                            ? this.props.currentRoute.replace("/", "")
                            : ""
                    }
                />
            </div>
        );
    }
}

export default withRouter(HeaderMenu);
